import { render } from "./FilterChip.vue?vue&type=template&id=9e37bc12&scoped=true"
import script from "./FilterChip.vue?vue&type=script&lang=js"
export * from "./FilterChip.vue?vue&type=script&lang=js"

import "./FilterChip.vue?vue&type=style&index=0&id=9e37bc12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e37bc12"]])

export default __exports__